// src/pages/fiscal/mdfe/VeiculoSearch.js
import React from 'react';
import CadastroFiscalSearch from './CadastroFiscalSearch';

const VeiculoSearch = ({ show, onHide, onSelectVeiculo, registros = [] }) => (
  <CadastroFiscalSearch show={show} onHide={onHide} titulo="Buscar Veículo" registros={registros}
    campos={['placa', 'renavam', 'uf']} onSelect={onSelectVeiculo} />
);
export default VeiculoSearch;
